//============================
//# mlsysisync_invhead
//# Interfész szinkron számlafej köztes tábla
//============================
import IfaceSync from "./IfaceSync";

export default interface IfaceSyncInvoiceHead extends IfaceSync {
    /** Belső geni id (mminigeninvoice.szam) */
    geniId: number;
    /** Belső noto id (hmouinotinvoice.szam) */
    notoId: number;
    /** Belső pregen id (hmouipregeninvoice.szam) */
    pregenId: number;
    /** Belső geno id (hmouigeninvoice.szam) */
    genoId: number;
    /** Szinkron iránya (IN/OUT) */
    direction: string;
    /** Számla mozgás típusa (SALE/PURCHASE) */
    invoiceKind: string;
    /** Másodlagos külső számlaazonosító */
    extCode2: string | null;
    /** Külső számlaszám */
    invNo: string | null;
    /** Külső számlaszám besorolása */
    invNoGroup: string | null;
    /** Külső számla típus */
    invType: string | null;
    /** Külső fizetési mód kód */
    payMode: string | null;
    /** Külső partner kód */
    partnerCode: string | null;
    /** Külső partner2 kód */
    partner2Code: string | null;
    /** Számlaszám */
    bankAccount: string | null;
    /** Számla rögzítés dátuma */
    invDate: Date | null;
    /** Számla rögzítés pontos ideje */
    invTime: Date | null;
    /** Számla beérkezésének dátuma */
    arrivDate: Date | null;
    /** Számla fizetési határideje */
    pterm: Date | null;
    /** Számla számviteli teljesítési dátuma */
    accDate: Date | null;
    /** Számla áfa törvény szerinti teljesítés dátuma */
    shipDate: Date | null;
    /** Az áfát erre a napra kell bevallani */
    vatDate: Date | null;
    /** Számla fizetési dátuma */
    payDate: Date | null;
    /** Számla jóváhagyás dátuma */
    apprDate: Date | null;
    /** Folyamatos teljesítésű? */
    shipDateC: boolean;
    /** Előlegszámla? */
    dpaym: boolean;
    /** Van beszámított előleg? */
    dpaymIncl: boolean;
    /** Beszámított előleg nettó */
    dpaymNetto: number | null;
    /** Beszámított előleg áfa */
    dpaymVat: number | null;
    /** Beszámított előleg bruttó */
    dpaymTotal: number | null;
    /** Helyesbítő számla? */
    rectify: boolean;
    /** Helyesbített számla külső számlaszáma */
    invRectify: string | null;
    /** Helyesbített számla áfa időszaka */
    rectVatDate: Date | null;
    /** Jóváíró számla? */
    storno: boolean;
    /** Jóváírt számla külső számlaszáma */
    invStorno: string | null;
    /** Nettó (HUF) */
    netto: number | null;
    /** Bruttó (HUF) */
    total: number | null;
    /** Áfa (HUF) */
    vat: number | null;
    /** Nettó a számla pénznemében */
    currNetto: number | null;
    /** Bruttó a számla pénznemében */
    currTotal: number | null;
    /** Áfa a számla pénznemében */
    currVat: number | null;
    /** Számla pénznem külső kód */
    invCurrency: string | null;
    /** Árfolyamszorzó */
    exchangeRate: number | null;
    /** Árfolyam dátuma */
    rateDate: Date | null;
    /** Partner főkönyvi szám */
    partnerAccNo: string | null;
    /** Költséghely külső kód */
    accGroupCode: string | null;
    /** Divitem kód */
    divItemCode: string | null;
    /** Megjegyzés1 */
    remark1: string | null;
    /** Megjegyzés2 */
    remark2: string | null;
    /** Külső gj. azonosító */
    car: string | null;
    /** Külső raktár azonosító */
    storeCode: string | null;
    /** Külső gyártmány azonosító */
    makeCode: string | null;
    /** Külső üzletág kód azonosító */
    branchCode: string | null;
    /** Külső rendszerben töröltként van megjelölve a számla? */
    deletedInExtSys: boolean;

    /** Kiválasztva (frontend only) */
    selected: boolean;
    /** Szerkesztés alatt (frontend only) */
    inEdit: boolean;
}

export const IfaceSyncInvoiceHeadDefaultProps: IfaceSyncInvoiceHead = {
    id: 1,
    extCode: '',
    interface: 1,
    syncStatus: 1,
    errorText: null,
    syncRemark: null,
    userModified: false,
    insDate: new Date(),
    insTime: new Date(),
    insUserId: 1,
    updDate: new Date(),
    updTime: new Date(),
    updUserId: 1,
    geniId: 1,
    notoId: 1,
    pregenId: 1,
    genoId: 1,
    direction: '',
    invoiceKind: '',
    extCode2: null,
    invNo: null,
    invNoGroup: null,
    invType: null,
    payMode: null,
    partnerCode: null,
    partner2Code: null,
    bankAccount: null,
    invDate: null,
    invTime: null,
    arrivDate: null,
    pterm: null,
    accDate: null,
    shipDate: null,
    vatDate: null,
    payDate: null,
    apprDate: null,
    shipDateC: false,
    dpaym: false,
    dpaymIncl: false,
    dpaymNetto: null,
    dpaymVat: null,
    dpaymTotal: null,
    rectify: false,
    invRectify: null,
    rectVatDate: null,
    storno: false,
    invStorno: null,
    netto: null,
    total: null,
    vat: null,
    currNetto: null,
    currTotal: null,
    currVat: null,
    invCurrency: null,
    exchangeRate: null,
    rateDate: null,
    partnerAccNo: null,
    accGroupCode: null,
    divItemCode: null,
    remark1: null,
    remark2: null,
    car: null,
    storeCode: null,
    makeCode: null,
    branchCode: null,
    deletedInExtSys: false,
    selected: false,
    inEdit: false,
}
